import React from 'react';
import { AppBar, Toolbar, Typography, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';

import MainView from './main';
import ContactView from './contact';
import AboutView from './about';

const useStyles = makeStyles(theme => ({
  header: {
    '& a': {
      color: '#fff',
      textDecoration: 'none'
    },
    '& a:hover': {
      textDecoration: 'underline'
    }
  },
  entry: {
    float: 'left',
    marginLeft: '20px'
  },
  appbar: {
    marginBottom: '25px'
  },
}));


const MainLayout = () => {

  const classes = useStyles();

  return (
    <div>
      <AppBar position="static" className={classes.appbar}>
        <Toolbar className={classes.header}>
          <Grid justify="space-between" container>
            <Grid item>
              <Typography noWrap variant="h6">
                <Link to="/">SentiVol</Link>
              </Typography>
            </Grid>
            <Grid item>
              <span className={classes.entry}>
                <Typography noWrap variant="h6">
                  <Link to="/about">About</Link>
                </Typography>
              </span>
              <span className={classes.entry}>
                <Typography noWrap variant="h6">
                  <Link to="/contact">Contact</Link>
                </Typography>
              </span>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
      <Switch>
        <Route path="/about">
          <AboutView />
        </Route>
        <Route path="/contact">
          <ContactView />
        </Route>
        <Route path="/">
          <MainView />
        </Route>
      </Switch>
    </div>
  );
};

const App = () => {
  return (
    <Router>
      <MainLayout/>
    </Router>
  );
};

export default App;
